export const getRealtimeBufferDuration = (): number => 5000;
export const getMaxBufferSize = (): number => 100;

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const isBrowserTabVisible = (): boolean => !document.hidden;
